export const DECK_PAGE_DESCRIPTION = [
  `This is the Deck Management section. `,
  `Here you can add the cards you earned to your deck. `,
  `Choose your cards carefully to create a powerful deck!`,
];

export const STORE_PAGE_DESCRIPTION = [
  `This is the Store section. `,
  `You can buy new cards here. `,
  `After buying a new card, make sure you add it to your deck in the “MY DECK” section.`,
];

export const RIVALS_PAGE_DESCRIPTION = [
  `This is the Rivals section. `,
  `Click on a rival to duel against him. `,
  `As you defeat rivals, new ones will be unlocked. `,
  `Can you defeat them all?`,
];

export const LEAGUE_PAGE_DESCRIPTION = [
  `Automatic duels are executed everyday. `,
  `In these duels run by AI, your deck is faced against other players decks. `,
  `Will your deck be able to climb to the top of the scoreboard? `,
];
